import {useMutation} from "@apollo/client";
import {Dispatch, SetStateAction} from "react";

import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {GQL_TEST_CONTACT_GROUP} from "@/lib/queries/contacts.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {ContactGroup} from "@/lib/types/contacts.ts";

export interface TestContactButtonActionProps {
  contact: ContactGroup;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
}

export const TestContactButtonAction = ({contact, show, setShow}: TestContactButtonActionProps) => {
  const [testContactGroup, {data, reset, loading, called}] = useMutation<GraphQLResponse<null>>(GQL_TEST_CONTACT_GROUP);
  const handleSubmit = async () => {
    await testContactGroup({
      variables: {
        id: contact.id,
      },
    });
  };
  const testComplete = called && data?.response.status === ResponseStatus.SUCCESS;
  return (
    <ActionDialog
      show={show}
      loading={loading}
      title={testComplete ? "Test Complete" : "Test Contact"}
      hasConfirmButton={!testComplete}
      confirmBtnText="Send Test"
      cancelBtnText={testComplete ? "Close" : "Cancel"}
      onConfirm={handleSubmit}
      onCancel={() => {
        setShow(false);
        reset();
      }}
    >
      {testComplete ? (
        <>
          Test notifications have been sent to <code>{contact.name}</code>.
        </>
      ) : (
        <>
          Do you want to send test notifications to Contact <code>{contact.name}</code>?
        </>
      )}
    </ActionDialog>
  );
};
